@if (isActive) {
  <topo-modal
    [isActive]="isActive"
    [backgroundCanClose]="true"
    [isCard]="true"
    [headerIsFullWidth]="true"
    [noHeaderBorder]="true"
    [removeHeaderBottomPadding]="true"
    [hideFooter]="true"
    [noBodyPadding]="true"
    [rawWidth]="'99vw'"
    [rawHeight]="'99vh'"
    (close)="close()">
    <div class="modal-header header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <div
          class="header"
          fxLayout="row"
          fxLayoutAlign="start center">
          <img src="assets/images/purple_bullhorn.svg" />
          <div class="title">{{ notification?.name }}</div>
        </div>
        <div
          class="button-container ml-2 pl-1 pr-1"
          fxLayout="row"
          fxLayoutAlign="center center">
          <div class="mr-3">
            <topo-header-bar-tab-button
              theme="white"
              [isSelected]="mainTabIndex === 0"
              [isSmall]="true"
              [label]="'COMMUNICATIONS.TAB-NOTIFICATION-DASHBOARD' | translate"
              (click)="onDashBoardTabSelected()"
            icon="icon-dashboard"></topo-header-bar-tab-button>
          </div>
          <div class="mr-3">
            <topo-header-bar-tab-button
              theme="white"
              [isSelected]="mainTabIndex === 1"
              [isSmall]="true"
              [label]="'COMMUNICATIONS.TAB-RECIPIENTS' | translate"
              (click)="onRecipientsTabSelected()"
            icon="icon-contact-list"></topo-header-bar-tab-button>
          </div>
          <div class="mr-3">
            <topo-header-bar-tab-button
              theme="white"
              [isSelected]="mainTabIndex === 2"
              [isSmall]="true"
              [label]="'COMMUNICATIONS.TAB-MESSAGE' | translate"
              (click)="onMessageTabSelected()"
            icon="icon-template"></topo-header-bar-tab-button>
          </div>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="end center"
          class="mr-3 save-buttons">
          <div class="ml-3">
            <button
              class="header-button save-button"
              [ngClass]="{ 'disabled': !isDirty }"
              [disabled]="!isDirty"
              [ngStyle]="{ 'visibility': isDirty ? 'visible' : 'hidden' }"
              (click)="onSaveAndClose()">
              <span>{{ 'MANAGEMENT.BUTTONS.SAVE-CLOSE' | translate }}</span>
            </button>
          </div>
          <div
            [ngStyle]="{ 'visibility': isDirty ? 'visible' : 'hidden' }"
            class="more-button"
            (click)="showSaveMenu($event)">
            <i class="icon icon-caret_down"></i>
            <topo-action-menu
              icon=""
              class="ml-2"
              [onShowMenu]="onShowMenu">
              <topo-action
                label="{{ 'MAP.SAVE' | translate }}"
                icon="icon-cloud_upload"
              (actionClick)="onSave()"></topo-action>
            </topo-action-menu>
          </div>
          <div
            class="dialog-close ml-2 header-close"
            (click)="close()">
            <i class="icon icon-close-X"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div
        fxLayout="row"
        fxLayoutAlign="start top"
        style="height: 100%">
        <!-- Left Drawer -->
        <div
          class="drawer-container"
          [class.open]="isDrawerOpen">
          <topo-comms-left-drawer
            height="calc(99vh - 90px)"
            [isOpen]="isDrawerOpen"
            [showOpenCloseHandle]="true"
            [handleTop]="80"
            (visibilityChanged)="drawerOpenClose($event)">
            <div class="details-container">
              <div>
                <div>
                  <topo-tabs
                    [selectedTabIndex]="selectedTabIndex"
                    [tabs]="tabs"
                  (selectedTabIndexChanged)="tabChanged($event)"></topo-tabs>
                </div>
                <!-- Overview -->
                @if (selectedTabIndex === 0) {
                  <div>
                    <topo-comms-notification-details
                      [notification]="notification"
                      (notificationWorkflowLoaded)="onNotificationWorkflowLoaded($event)"
                    (recipientWorkflowLoaded)="onRecipientWorkflowLoaded($event)"></topo-comms-notification-details>
                  </div>
                }
              </div>
            </div>
          </topo-comms-left-drawer>
        </div>
        <!-- Main Content -->
        <div
          class="content-container"
          [ngClass]="{ 'drawer-open': isDrawerOpen, 'main-content': mainTabIndex === 0 }">
          @if (mainTabIndex === 0) {
            <topo-comms-notification-dashboard
              height="calc(99vh - 124px)"
              [chartWidth]="getChartWidth()"
              [barWidth]="getBarWidth()"
              [notification]="notification"
              [template]="template"
              [notificationWorkflow]="notificationWorkflow"
              (notificationNavigateRequested)="onNotificationNavigate($event)"
            ></topo-comms-notification-dashboard>
          }
          @if (mainTabIndex === 1) {
            <div
              class="table-container">
              <topo-comms-notification-recipients
                [height]="'calc(99vh - 240px)'"
                [notification]="notification"
              (recipientClicked)="onRecipientDetalsRequested($event)"></topo-comms-notification-recipients>
            </div>
          }
          @if (mainTabIndex === 2) {
            <div>
              <div
                fxLayout="row"
                fxLayoutAlign="center top"
                class="message-tabs">
                <topo-tabs
                  [selectedTabIndex]="selectedMessageTabIndex"
                  [tabs]="messageTabs"
                  [icons]="messageTabIcons"
                (selectedTabIndexChanged)="onMessageTabChanged($event)"></topo-tabs>
              </div>
              <div class="message-container">
                @if (isEmailTemplate) {
                  <div
                    fxLayout="row"
                    fxLayoutAlign="center top">
                    <div class="email-subject-container">
                      <div class="field mt-4">
                        <label>{{ (isTemplateTitle ? 'COMMUNICATIONS.TITLE' : 'COMMUNICATIONS.EMAIL-SUBJECT') | translate }}</label>
                        <div>
                          {{ emailSubject }}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (isTemplateSummary) {
                  <div
                    fxLayout="row"
                    fxLayoutAlign="center top">
                    <div class="email-subject-container">
                      <div class="field">
                        <label>{{ 'COMMUNICATIONS.SUMMARY' | translate }}</label>
                        <div>
                          {{ templateSummary }}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <div
                  fxLayout="row"
                  fxLayoutAlign="center top">
                  <div
                    class="designer-container"
                    [ngClass]="{ 'has-email-subject': isEmailTemplate }">
                    <topo-comms-template-designer
                      width="800px"
                      [culture]="selectedCulture"
                      [editable]="false"
                      [editableControlTypes]="editableControlTypes"
                      [deletableControlTypes]="deletableControlTypes"
                      [messageSettings]="notification?.messageSettings"
                      [documentContext]="documentContext"
                      [template]="selectedCommunicationTemplate"
                    [overrides]="notification?.viewControlOverrides"></topo-comms-template-designer>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <!-- Escalated responses Area -->
        @if (mainTabIndex === 0) {
          <div
            class="escalated-container">
            <topo-comms-notification-responses
              [notification]="notification"
              [recipientWorkflow]="recipientWorkflow"
            (recipientClicked)="onRecipientDetalsRequested($event)"></topo-comms-notification-responses>
          </div>
        }
      </div>
      <!-- Recipient details area -->
      <topo-right-drawer
        [isOpen]="!!recipientForDetails"
        [isMap]="false"
        (visibilityChanged)="rightDrawerVisibilityChanged($event)">
        <topo-comms-recipient-details
          [notification]="notification"
          [recipient]="recipientForDetails"
          [recipientWorkflow]="recipientWorkflow"
        (recipientsDetailsClosed)="onRecipientsDetailsClosed()"></topo-comms-recipient-details>
      </topo-right-drawer>
    </div>
  </topo-modal>
}
